module.exports = __webpack_public_path__ + "static/media/Tel.54b6c5b1.svg";